import { Stack, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { EyeIcon } from "../../images/EyeIcon";
import { userApi, useUpdateClientViewMutation } from "../../../api";
import { useAppDispatch } from "../../../hooks";
import { toast } from "react-toastify";
import { CustomToast } from "../CustomToast";
import { getErrorMessage } from "../../../utils/getErrorMessage";

export const ClientModeSwitcher = ({ clientView }: { clientView: boolean }) => {
  const dispatch = useAppDispatch();
  const [isClientView, setIsClientView] = useState<boolean>(clientView);

  const [changeClientView, { isLoading }] = useUpdateClientViewMutation();

  useEffect(() => {
    setIsClientView(clientView);
  }, [clientView]);

  const changeHandler = () => {
    const next = !isClientView;
    setIsClientView(next);

    changeClientView(next)
      .unwrap()
      .then(() => {
        dispatch(userApi.util.invalidateTags(["user"]));
      })
      .catch((error) => {
        setIsClientView((prev) => !prev);

        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(error).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Failed to Switch Client Mode"}
          />,
        );
      });
  };

  return (
    <Stack
      sx={{
        backgroundColor: isClientView ? "#D3EAF6" : "transparent",
        borderRadius: "8px",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginX: "8px",
        padding: "0 12px 0 8px",
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <EyeIcon color={isClientView ? "#1C3C6C" : undefined} />
        <Typography
          fontWeight={500}
          fontSize="14px"
          lineHeight="20px"
          sx={{ color: "#4C545B" }}
        >
          Client View
        </Typography>
      </Stack>
      <Switch
        checked={isClientView}
        disabled={isLoading}
        onChange={changeHandler}
        inputProps={{ "aria-label": "controlled" }}
      />
    </Stack>
  );
};
